import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { RaRecord, TopToolbar } from 'react-admin'
import { SvgField, ToolbarTitle } from '..'

export const ActionsToolbar = (props: ActionsToolbarProps): JSX.Element => {
  const {
    children,
    i18n,
    icon,
    record,
    source,
    tag,
    to,
    ...rest
  } = props

  return (
    <StyledTopToolbar {...rest} className={classes.toolbar}>
      {icon && (
        <div className={classes.iconContainer}>
          <SvgField source={icon} />
        </div>
      )}
      <ToolbarTitle record={record} source={source} i18n={i18n} className={classes.title} />
      {tag}
      <span className={classes.spacer} />
      {children}
    </StyledTopToolbar>
  )
}

interface ActionsToolbarProps {
  children?: React.ReactNode;
  classes?: {
    toolbar?: string;
    spacer?: string;
    title?: string;
    iconContainer?: string;
  };
  i18n?: string;
  icon?: string;
  record?: RaRecord;
  source?: string;
  tag?: React.ReactNode;
  to?: string;
}

ActionsToolbar.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  i18n: PropTypes.string,
  icon: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string,
  sx: PropTypes.any,
  tag: PropTypes.node,
  to: PropTypes.string,
}

const PREFIX = 'xxllncActionsToolbar'

const classes = {
  toolbar: `${PREFIX}-toolbar`,
  spacer: `${PREFIX}-spacer`,
  title: `${PREFIX}-title`,
  iconContainer: `${PREFIX}-iconContainer`,
}

const StyledTopToolbar = styled(TopToolbar)(({ theme }) => ({
  [`&.${classes.toolbar}`]: {
    justifyContent: 'flex-start',
    padding: '24px 16px',
    gap: theme.spacing(4),
    flexDirection: 'row-reverse',
  },
  [`& .${classes.spacer}`]: {
    flex: 1,
  },
  [`& .${classes.title}`]: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '28px',
    marginRight: 'auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingLeft: '24px',
  },
  [`& .${classes.iconContainer}`]: {
    borderRadius: 8,
    height: 32,
    lineHeight: 0,
    marginRight: theme.spacing(1),
    maxWidth: 32,
    overflow: 'hidden',
    ['& img']: {
      height: '100%',
      width: '100%',
    }
  },
}))
